import { isEmpty } from '@ember/utils'
import fillMonths from 'district-ui-client/utils/student-events/fill-months'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'

export interface TimeOnTaskUsageResponse {
  time_on_task_summary: SummaryData
  time_on_task_by_month: MonthData[]
}

type SummaryData = {
  session_count: number
  student_count: number
  total_seconds: number
  average_seconds_per_session: Nullable<number>
  average_seconds_per_student: Nullable<number>
  average_seconds_per_student_per_week: Nullable<number>
  average_sessions_per_student: Nullable<number>
}

type MonthData = {
  month: string
  seconds: number
}

export type TimeOnTaskUsageData = {
  summary: SummaryData
  months: MonthData[]
}

export async function timeOnTaskUsage(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  statsScope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<TimeOnTaskUsageData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('time_on_task_usage', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<TimeOnTaskUsageResponse>(url, query)
  if (!data) return null

  const { time_on_task_summary, time_on_task_by_month } = data
  if (time_on_task_by_month.length === 0) return null

  return {
    summary: time_on_task_summary,
    months: fillMonths(time_on_task_by_month, period, { seconds: 0 }),
  }
}
